import React from 'react';
import Image from 'next/legacy/image';
import classnames from 'classnames';
import classNames from 'classnames';

export interface ExpertCardProps {
  image: string;
  firstName?: string;
  lastName?: string;
  job?: string;
  className?: string;
}

export const expertCardHeightConfig = 'h-[120px] md:h-[184px] xl:h-[240px]';

const ExpertCard: React.FC<ExpertCardProps> = ({
  image,
  firstName,
  lastName,
  job,
  className,
}) => {
  return (
    <div
      className={classnames(
        'flex flex-col items-center group cursor-pointer',
        className
      )}
    >
      <div
        className={classNames(
          'relative md:w-[146px] w-[143px] xl:w-[190px]',
          expertCardHeightConfig
        )}
      >
        <Image
          src={image}
          alt={
            firstName || lastName
              ? `Expert ${firstName || ''} ${lastName || ''}`.trim()
              : 'Real estate expert photo'
          }
          layout="fill"
          objectFit="cover"
          className="transition-transform duration-300 hover:scale-105"
        />
      </div>
      {(firstName || lastName) && (
        <div className="font-sohneBreitHalbfett uppercase group-hover:text-gold-hover">
          {firstName && <p>{firstName}</p>}
          {lastName && <p>{lastName}</p>}
        </div>
      )}
      {job && (
        <div className="text-14-26-0.3 xl:text-16-21-0.3 text-black group-hover:text-gold-hover">
          {job}
        </div>
      )}
    </div>
  );
};

export default ExpertCard;
